/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkActivity} from '../models/BulkActivity';
import type {Error} from '../models/Error';
import type {SortDirection} from '../models/SortDirection';

export interface GetUserBulkActivity$Request {
    userId: number;
    pageNumber: number;
    pageSize: number;
    sortDirection?: SortDirection;
}

export interface GetUserBulkActivity$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserBulkActivityRequest = createAction<PayloadData<void, GetUserBulkActivity$Request>>('BULK_ACTIVITY_LOG__GET_USER_BULK_ACTIVITY__REQUEST');
export const getUserBulkActivitySuccess = createAction<PayloadData<BulkActivity, GetUserBulkActivity$Request>>('BULK_ACTIVITY_LOG__GET_USER_BULK_ACTIVITY__SUCCESS');
export const getUserBulkActivityFailure = createAction<PayloadData<Error, GetUserBulkActivity$Request, true>>('BULK_ACTIVITY_LOG__GET_USER_BULK_ACTIVITY__FAILURE');

export const getUserBulkActivityActions = [
    getUserBulkActivityRequest,
    getUserBulkActivitySuccess,
    getUserBulkActivityFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {number} meta.pageNumber
 * @param {number} meta.pageSize
 * @param {SortDirection} [meta.sortDirection]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserBulkActivity = (meta: GetUserBulkActivity$Request, config?: GetUserBulkActivity$Config) => {
    const TRANSPORT_GET_PARAMS = {
        sortDirection: meta.sortDirection,
        pageNumber: meta.pageNumber,
        pageSize: meta.pageSize,
    };
    return {
        CALL_API: {
            types: getUserBulkActivityActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/${meta.userId}/activity`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

